// SectionHeader — title + optional subtitle and trailing action, shared by
// the BusinessEditor section cards. Lifted verbatim from BusinessEditor.

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div className="mb-4 flex items-start justify-between gap-3 border-b border-default pb-3">
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-semibold text-primary">{title}</h2>
        {subtitle ? <p className="text-xs text-tertiary">{subtitle}</p> : null}
      </div>
      {action}
    </div>
  );
}
